<template>
  <v-container id="evidence-list">
    <city-header :payload="city"> </city-header>

    <v-row>
      <v-col>Perguntas</v-col>
      <v-col class="text-right">
        <v-btn
          v-if="
            isAdmin ||
            isConsultorCondutorMunicipio ||
            isConsultorEspecialistaMunicipio ||
            isADMunicipio
          "
          outlined
          color="primary"
          class="ml-3"
          @click="loadQuestions"
        >
          <span>Download PDF Perguntas</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-bottom-navigation :value="activeBtn" color="primary">
          <v-divider vertical></v-divider>

          <v-btn
            :to="'/cidade/' + payload.municipioId + '/evidencia/respondida'"
            @click="tabsChoosed = 1"
          >
            <span>Respondidas</span>
          </v-btn>
          <v-divider vertical></v-divider>

          <v-btn
            :to="'/cidade/' + payload.municipioId + '/evidencia/evidenciada'"
            @click="tabsChoosed = 2"
          >
            <span>Evidenciadas em Análise</span>
          </v-btn>
          <v-divider vertical></v-divider>

          <v-btn
            :to="'/cidade/' + payload.municipioId + '/evidencia/aprovada'"
            @click="tabsChoosed = 3"
          >
            <span>Aprovadas</span>
          </v-btn>
          <v-divider vertical></v-divider>

          <v-btn
            :to="'/cidade/' + payload.municipioId + '/evidencia/rejeitada'"
            @click="tabsChoosed = 4"
          >
            <span>Rejeitadas</span>
          </v-btn>

          <v-divider vertical></v-divider>
        </v-bottom-navigation>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <app-tema-combobox @onChange="changeTemaIds"></app-tema-combobox>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <app-evidence-respondida
          v-if="tabsChoosed === 1"
          :filter="filter"
        ></app-evidence-respondida>
        <app-evidence-evidenciada
          v-if="tabsChoosed === 2"
          :filter="filter"
        ></app-evidence-evidenciada>
        <app-evidence-aprovadas
          v-if="tabsChoosed === 3"
          :filter="filter"
        ></app-evidence-aprovadas>
        <app-evidence-rejeitadas
          v-if="tabsChoosed === 4"
          :filter="filter"
        ></app-evidence-rejeitadas>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CityHeader from "../Header";
import { cityAPI, cityQuestionAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import AppEvidenceRespondida from "./Respondidas";
import AppEvidenceEvidenciada from "./Evidenciada";
import AppEvidenceAprovadas from "./Aprovadas";
import AppEvidenceRejeitadas from "./Rejeitadas";
import AppTemaCombobox from "@/modules/tema/components/TemaCombobox";

export default {
  components: {
    CityHeader,
    AppEvidenceRespondida,
    AppEvidenceEvidenciada,
    AppEvidenceAprovadas,
    AppEvidenceRejeitadas,
    AppTemaCombobox,
  },
  data() {
    return {
      headers: [
        { text: "Tema", value: "pergunta.tema.nome" },
        { text: "Número", value: "pergunta.numero" },
        { text: "Texto", value: "pergunta.texto" },
        { text: "Pontos", value: "pergunta.pontos" },
        { text: "", value: "enviar" },
        { text: "", value: "acao" },
        { text: "Evidência", value: "pergunta.evidencia" },
      ],
      expanded: [],
      payload: {
        municipioId: this.$route.params.id,
        perguntas: [],
      },
      tabsChoosed: 1,
      activeBtn: 0,
      perguntas: [],
      city: {},
      filter: {
        municipioId: this.$route.params.id,
        temas: [],
      },
    };
  },
  methods: {
    ...mapActions([
      "setLoading",
      "setConsultorCondutorMunicipio",
      "setConsultorEspecialistaMunicipio",
      "setAnalistaMunicipio",
      "setADMunicipio",
    ]),
    changeTemaIds(e) {
      this.filter.temas = e;
    },

    updateQuestion(e) {
      this.payload.perguntas = this.payload.perguntas.map((item) => {
        if (item.perguntaMunicipioId === e.perguntaMunicipioId) {
          return {
            ...item,
            ...e,
          };
        }
        return item;
      });
    },

    loadQuestions() {
      this.setLoading(true);
      cityQuestionAPI
        .getPerguntas(this.$route.params.id)
        .then((resp) => {
          this.perguntas = resp.data;
          this.setLoading(false);
          this.createPDF();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter perguntas");
        });
    },
    createPDF() {
      this.setLoading(true);
      cityQuestionAPI
        .getPDFPerguntas(this.filter)
        .then((resp) => {
          let blob = new Blob([resp.data], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Perguntas - " + this.filter.nome + ".pdf";
          link.click();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter PDF de perguntas");
        });
    },
    loadCity() {
      cityAPI
        .get(this.$route.params.id)
        .then((resp) => {
          this.city = resp.data;
          this.filter.nome = this.city.nome;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter município");
        });
    },
  },
  mounted() {
    this.loadCity();
    this.setConsultorCondutorMunicipio(this.$route.params.id);
    this.setConsultorEspecialistaMunicipio(this.$route.params.id);
    this.setAnalistaMunicipio(this.$route.params.id);
    this.setADMunicipio(this.$route.params.id);
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "uf",
      "logo",
    ]),
  },
};
</script>

<style lang="scss">
a {
  text-decoration: none;
}
.p-0 {
  padding: 0 !important;
}
.hasEvidence {
  background: url("/assets/img/certo1.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
  margin: 0 auto;
}
.hasNoEvidence {
  background: url("/assets/img/noEvidence.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
  margin: 0 auto;
}
.semStatus {
  background: url("/assets/img/search.png") no-repeat;
  width: 30px;
  height: 30px;
  display: block;
  background-size: contain;
  /* text-align: center; */
  margin: 0 auto;
}

.optionsExpanded {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.openExpanded {
  background: url("/assets/img/right-arrow.png") no-repeat;
  width: 20px;
  height: 20px;
  transform: rotate(90deg);
  display: block;
  background-size: contain;
  /* text-align: center; */
  margin: 0 auto;
  float: right;
}
.expandedClass {
  transform: rotate(270deg);
}
</style>
